import { render } from "./UIUXHero.vue?vue&type=template&id=5e03ff4e"
import script from "./UIUXHero.vue?vue&type=script&lang=js"
export * from "./UIUXHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__